<template>
    <div class="modal-wrapper">
        <div class="modal-header">
            <h4>{{ $t("labels.destinyChoose") }}</h4>
            <span @click="closeModal" class="fas fa-times"></span>
        </div>
        <div class="inner-container">
            <div class="form-group">
                <label>{{ $t("labels.mainDestinyChoose") }}</label>
                <div class="areas-wrapper">
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === LEARNING_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/nauka_jazdy.png`)"
                             alt="nauka_jazdy"
                             :class="{
                selected: mainDestiny === LEARNING_ID,
              }"
                             @click="selectMainDestiny(LEARNING_ID)" />
                        <span>{{ $t("labels.learning") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === WORK_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/praca.png`)"
                             alt="praca"
                             :class="{
                selected: mainDestiny === WORK_ID,
              }"
                             @click="selectMainDestiny(WORK_ID)" />
                        <span>{{ $t("labels.work") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === RECREATION_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/rekreacja.jpg`)"
                             alt="rekreacja"
                             :class="{
                selected: mainDestiny === RECREATION_ID,
              }"
                             @click="selectMainDestiny(RECREATION_ID)" />
                        <span>{{ $t("labels.recreation") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === SPORT_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/sport.jpg`)"
                             alt="sport"
                             :class="{
                selected: mainDestiny === SPORT_ID,
              }"
                             @click="selectMainDestiny(SPORT_ID)" />
                        <span>{{ $t("labels.sport") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === SCHOOL_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/szkola.jpg`)"
                             alt="school"
                             :class="{
                selected: mainDestiny === SCHOOL_ID,
              }"
                             @click="selectMainDestiny(SCHOOL_ID)" />
                        <span>{{ $t("labels.school") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: mainDestiny === EVERYDAY_ID }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/codziennosc.jpg`)"
                             alt="codziennosc"
                             :class="{
                selected: mainDestiny === EVERYDAY_ID,
              }"
                             @click="selectMainDestiny(EVERYDAY_ID)" />
                        <span>{{ $t("labels.everyday") }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-container">
            <div class="form-group">
                <label>{{ $t("labels.optionalDestinyChoose") }}</label>
                <div class="areas-wrapper">
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(LEARNING_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/nauka_jazdy.png`)"
                             alt="nauka_jazdy"
                             :class="{
                selected: optionalDestinies.includes(LEARNING_ID),
                disabled: mainDestiny === LEARNING_ID,
              }"
                             @click="selectOptionalDestiny(LEARNING_ID)" />
                        <span>{{ $t("labels.learning") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(WORK_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/praca.png`)"
                             alt="praca"
                             :class="{
                selected: optionalDestinies.includes(WORK_ID),
                disabled: mainDestiny === WORK_ID,
              }"
                             @click="selectOptionalDestiny(WORK_ID)" />
                        <span>{{ $t("labels.work") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(RECREATION_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/rekreacja.jpg`)"
                             alt="rekreacja"
                             :class="{
                selected: optionalDestinies.includes(RECREATION_ID),
                disabled: mainDestiny === RECREATION_ID,
              }"
                             @click="selectOptionalDestiny(RECREATION_ID)" />
                        <span>{{ $t("labels.recreation") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(SPORT_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/sport.jpg`)"
                             alt="sport"
                             :class="{
                selected: optionalDestinies.includes(SPORT_ID),
                disabled: mainDestiny === SPORT_ID,
              }"
                             @click="selectOptionalDestiny(SPORT_ID)" />
                        <span>{{ $t("labels.sport") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(SCHOOL_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/szkola.jpg`)"
                             alt="school"
                             :class="{
                selected: optionalDestinies.includes(SCHOOL_ID),
                disabled: mainDestiny === SCHOOL_ID,
              }"
                             @click="selectOptionalDestiny(SCHOOL_ID)" />
                        <span>{{ $t("labels.school") }}</span>
                    </div>
                    <div class="area-tile">
                        <span class="tile-icon" :class="{ visible: optionalDestinies.includes(EVERYDAY_ID) }">
                            <i class="fas fa-check"></i>
                        </span>
                        <img :src="require(`@/assets/images/destinies/codziennosc.jpg`)"
                             alt="codziennosc"
                             :class="{
                selected: optionalDestinies.includes(EVERYDAY_ID),
                disabled: mainDestiny === EVERYDAY_ID,
              }"
                             @click="selectOptionalDestiny(EVERYDAY_ID)" />
                        <span>{{ $t("labels.everyday") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapFields } from "vuex-map-fields";

    // methods
    import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";
    import setCookie from "@/utils/setCookie";

    // css
    import "./Modal.scss";

    export default {
        name: "DestinyModal",
        props: {
            destinies: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                LEARNING_ID: this.destinies.filter((el) => el.Text === "nauka jazdy")[0].Value,
                WORK_ID: this.destinies.filter((el) => el.Text === "do pracy")[0].Value,
                RECREATION_ID: this.destinies.filter((el) => el.Text === "rekreacyjnie")[0].Value,
                SPORT_ID: this.destinies.filter((el) => el.Text === "sportowo")[0].Value,
                SCHOOL_ID: this.destinies.filter((el) => el.Text === "do szkoły")[0].Value,
                EVERYDAY_ID: this.destinies.filter((el) => el.Text === "codzienna jazda")[0].Value,
            };
        },
        computed: {
            ...mapFields(["filters.mainDestiny", "filters.optionalDestinies"]),
        },
        watch: {
            mainDestiny: function (newVal) {
                setCookie("mainDestiny", newVal, this);
                updateUrlParams();
            },
            optionalDestinies: function (newVal) {
                setCookie("optionalDestinies", newVal.join(), this);
                updateUrlParams();
            },
        },
        methods: {
            closeModal() {
                this.$emit("closeModal");
            },
            selectMainDestiny(destiny) {
                if (this.optionalDestinies.includes(destiny)) {
                    const index = this.optionalDestinies.indexOf(destiny);
                    if (index > -1) {
                        this.optionalDestinies.splice(index, 1);
                    }
                }
                if (this.mainDestiny === destiny) {
                    this.mainDestiny = null;
                } else {
                    this.mainDestiny = destiny;
                }
            },
            selectOptionalDestiny(destiny) {
                if (this.mainDestiny === destiny) return;
                if (this.optionalDestinies.includes(destiny)) {
                    const index = this.optionalDestinies.indexOf(destiny);
                    if (index > -1) {
                        this.optionalDestinies.splice(index, 1);
                    }
                } else {
                    this.optionalDestinies.push(destiny);
                }
            },
            getCookies() {
                const mainDestiny = this.$cookies.get("mainDestiny");
                if (mainDestiny != null && mainDestiny != "") this.mainDestiny = +mainDestiny;

                const optionalDestinies = this.$cookies.get("optionalDestinies");
                if (optionalDestinies) {
                    let cookieOptionalDestinies = optionalDestinies.split(",");
                    if (cookieOptionalDestinies) {
                        for (let i = 0; i < cookieOptionalDestinies.length; i++) {
                            cookieOptionalDestinies[i] = +cookieOptionalDestinies[i];
                        }
                        this.optionalDestinies = cookieOptionalDestinies;
                    }
                }
            },
        },
        mounted() {
            this.getCookies();
        },
    };
</script>
